(function() {
  'use strict';

  var hostname = String(document.location.hostname).split('.')[0];

  window.cfnGlobals = {
    isDev: hostname !== 'app' && hostname !== 'preprod' && hostname !== 'demo'
  };
})();
